var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelDashboardResponseTimeInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Info_12px",
    d: "M4.5,0A4.5,4.5,0,1,0,9,4.5,4.5,4.5,0,0,0,4.5,0Zm0,2.156a.469.469,0,1,1-.468.469A.469.469,0,0,1,4.5,2.156ZM5.25,6.75H3.75V6.375c.181-.067.375-.075.375-.276V4.424c0-.2-.194-.232-.375-.3V3.75H4.875V6.1c0,.2.194.209.375.276Z",
    fill: "#6d7077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelDashboardResponseTimeInfoIcon);
export default __webpack_public_path__ + "static/media/channel-dashboard-response-time-info-icon.f616572ab74c4feb055865ba9da2b387.svg";
export { ForwardRef as ReactComponent };